// jobService.js
import { initDB } from "../db";

const generateId = () => `${Date.now()}-${Math.floor(Math.random() * 10000)}`;

let subscribers = [];

export const subscribeToJobs = (callback) => {
  subscribers.push(callback);
  return () => {
    subscribers = subscribers.filter((cb) => cb !== callback);
  };
};

export const notifyJobUpdate = async () => {
  const jobs = await getJobsFromStorage();
  // Only pass jobs length to subscribers instead of full jobs array
  const jobsLength = Array.isArray(jobs) ? jobs.length : 0;
  subscribers.forEach((cb) => cb(jobsLength));
};

export const getJobsFromStorage = async () => {
  const db = await initDB();
  return await db.getAll("jobs");
};

export const getJobById = async (jobId) => {
  try {
    const db = await initDB();
    const job = await db.get("jobs", jobId);
    return job || null;
  } catch (error) {
    console.error("Error getting job by ID:", error);
    return null;
  }
};

export const statusPriority = {
  processing: 1,
  pending: 2,
  failed: 3,
  success: 4,
};

export const setJobToStorage = async (job) => {
  const db = await initDB();
  await db.put("jobs", job);
  notifyJobUpdate();
};

export const addJob = async (job) => {
  const metaData = {
    retry: 3,
    interval: 0,
  };

  const newJob = {
    ...job,
    metaData: { ...metaData, ...job?.metaData },
    id: job?.id || generateId(),
    date: Date.now(),
    status: "pending", // pending | success | failed
    attempts: 0,
  };

  await setJobToStorage(newJob);
};
